import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import SharedRaw from "./SharedRaw";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/shared/raw/:shareId/:name" element={<SharedRaw />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  );
}
